// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"451e5864","29":"467ec5b4","279":"19d36f7e","295":"71851742","378":"7352b18e"}[chunkId] + ".chunk.js";
};